//
//
//
//
//
//
//
//

export default {
  data: () => ({
    visible: false,
    body: null
  }),
  methods: {
    show (event) {
      this.body = event.currentTarget.outerHTML
      this.visible = true

      this.$nextTick(() => {
        this.$el.scrollLeft = this.$el.scrollWidth / 2 - this.$el.clientWidth / 2
      })
    },
    close () {
      this.visible = false
      this.body = null
    }
  }
}
